export * from './support'
export * from './message'
export * from './user'
export * from './interaction'
export * from './company'
export * from './post'
export * from './invite'

export type InteractionType = 'like' | 'comment' | 'share'

export interface Interaction {
  id: string
  type: InteractionType
  postId: string
  userId: string
  userName?: string
  userPicUrl?: string
  data?: string
  createdAt?: any
  parentId?: string
  parentUserName?: string
  replyingToUserId?: string
}

export interface InteractionInput {
  type: InteractionType
  postId: string
  userId: string
  userName?: string
  userPicUrl?: string
  data?: string
  parentId?: string
  parentUserName?: string
  replyingToUserId?: string
}

import type { Timestamp } from 'firebase/firestore'
import type { CompanyUserRole } from './companyUser'
import type { User } from './user'

export interface PendingUser {
  id: string
  email: string
  role: CompanyUserRole
  invitedAt: Timestamp
  expiresAt: Timestamp
  inviterID?: string
  isPending: true
}

export type UserOrPending = User | PendingUser
